import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import FmDirectoryEditDto from 'app/admin/fileManager/dto/FmDirectoryEditDto';
import nBossConnection from 'modules/base/service/nBossConnection';

class FmDirectoryEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'fmDirectoryEditControl';
	}

	/**
	 * @return {Promise<FmDirectoryEditDto>>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new FmDirectoryEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<FmDirectoryEditDto>>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new FmDirectoryEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {FmDirectoryEditDto} dto
	 * @return {Promise<EntityValidationResult>>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {FmDirectoryEditDto} dto
	 * @return {Promise<EntityValidationResult>>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new FmDirectoryEditService();
